module.exports = __webpack_public_path__ + "media/images/icon__facebook@3x-069b994124f262bb7e954c94e5c4f0ad.png";